import { forwardRef } from "react";
import { Link, Form, useRouteLoaderData } from "react-router-dom";
import { PARAMS } from "../util/GlobalConstants";
import { useTranslation } from "react-i18next";
import { Navbar, Nav, Button } from "rsuite";
import { useDispatch, useSelector } from "react-redux";
import { sidebarActions } from "../store/sidebar-slice";
import { themeActions } from "../store/theme-slice";
import { commandsActions } from "../store/commands-slice";
import HomeIcon from "@rsuite/icons/legacy/Home";
import GlobalIcon from "@rsuite/icons/Global";
import MenuIcon from "@rsuite/icons/Menu";
import AdminIcon from "@rsuite/icons/Admin";
import ExitIcon from "@rsuite/icons/Exit";
import UserInfoIcon from "@rsuite/icons/UserInfo";
import BrushIcon from "@rsuite/icons/legacy/PaintBrush";
import ZionLogo from "./ZionLogo";
import "./MainNavigation.css";

const THEME_OPTIONS = [
  "light",
  "dark",
  "ocean",
  "forest",
  "sunset",
  "royal",
  "slate",
  "midnight",
  "ember",
  "arctic",
  "copper",
  "lavender",
  "emerald",
  "carbon",
  "wine",
  "sand",
  "cobalt",
];

function MainNavigation() {
  const token = useRouteLoaderData("root");
  const [t, i18n] = useTranslation();
  const theme = useSelector((state) => state.theme.currentTheme);
  const dispatch = useDispatch();

  const customLink = forwardRef(({ href, children, ...rest }, ref) => (
    <Link ref={ref} to={href} {...rest}>
      {children}
    </Link>
  ));

  const menuHandler = () => {
    dispatch(sidebarActions.toggle());
  };

  const themeHandler = (newTheme) => {
    dispatch(themeActions.change(newTheme));
  };

  return (
    <header>
      <Navbar appearance="subtle" className="nabvar-container">
        <Nav className="nav-main">
          {token && (
            <Nav.Item
              icon={<MenuIcon />}
              onClick={menuHandler}
              className="nab-main-icon"
            ></Nav.Item>
          )}
          <Nav.Item href="/" className="nav-main-title" as={customLink}>
            <span className="brand-lockup">
              <span className="brand-mark">
                <ZionLogo size={26} />
              </span>
              <span className="brand-text">
                <span className="brand-name">ZION</span>
                <span className="brand-sub">Control Center</span>
              </span>
            </span>
          </Nav.Item>
        </Nav>
        <Nav pullRight>
          {token && (
            <Nav.Item
              icon={<HomeIcon />}
              href="/"
              as={customLink}
              className="d-none d-lg-flex"
            >
              {t("main-navigation.home")}
            </Nav.Item>
          )}
          {token && (
            <Nav.Menu
              title={t("main-navigation.themes")}
              icon={<BrushIcon />}
              className="hidden-768"
            >
              {THEME_OPTIONS.map((option) => (
                <Nav.Item
                  key={option}
                  onClick={() => themeHandler(PARAMS.theme[option])}
                  active={theme === PARAMS.theme[option]}
                >
                  {t("main-navigation." + (option === "light" ? "ligth" : option))}
                </Nav.Item>
              ))}
            </Nav.Menu>
          )}
          <Nav.Menu
            title={i18n.language === "es" ? "ES" : "EN"}
            icon={<GlobalIcon />}
            className="hidden-576 nav-lang-menu"
          >
            <Nav.Item
              onClick={() => i18n.changeLanguage("en")}
              active={i18n.language === "en" ? true : false}
              className="nav-lang-item"
            >
              English
            </Nav.Item>
            <Nav.Item
              onClick={() => i18n.changeLanguage("es")}
              active={i18n.language === "es" ? true : false}
              className="nav-lang-item"
            >
              Español
            </Nav.Item>
          </Nav.Menu>
          {!token && (
            <Nav.Item
              icon={<AdminIcon />}
              href={`/auth?${PARAMS.mode.mode}=${PARAMS.mode.login}`}
              as={customLink}
              className="nav-login-btn"
            >
              {t("main-navigation.login")}
            </Nav.Item>
          )}
          {token && (
            <Nav.Item
              icon={<UserInfoIcon />}
              href="/profile"
              as={customLink}
              className="nav-profile-item"
            >
              {t("main-navigation.profile")}
            </Nav.Item>
          )}
          {token && (
            <Nav.Item icon={<ExitIcon />} href="/logout">
              <Form action="/logout" method="post">
                <Button
                  className="no-button rs-navbar-item"
                  type="submit"
                  onClick={() => dispatch(commandsActions.update([]))}
                >
                  {t("main-navigation.logout")}
                </Button>
              </Form>
            </Nav.Item>
          )}
        </Nav>
      </Navbar>
    </header>
  );
}

export default MainNavigation;
